if (!customElements.get('sb-image-text-accordion')) {
  customElements.define(
    'sb-image-text-accordion',
    class SbImageTextAccordion extends HTMLElement {
      constructor() {
        super();
        this.activeIndex = 0;
      }

      connectedCallback() {
        this.mediaItems = this.querySelectorAll('[data-sb-ita-media]');
        this.items = this.querySelectorAll('[data-sb-ita-item]');
        this.triggers = this.querySelectorAll('[data-sb-ita-trigger]');

        const defaultIndex = parseInt(this.getAttribute('data-default-index') || '0', 10);
        this.activate(defaultIndex, false);

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const idx = parseInt(trigger.getAttribute('data-sb-ita-trigger'), 10);
            this.activate(idx, true);
          });
        });
      }

      activate(index, focusTrigger) {
        if (index === this.activeIndex && focusTrigger) return;
        this.activeIndex = index;
        const key = String(index);

        this.mediaItems.forEach((el) => {
          el.classList.toggle('is-active', el.getAttribute('data-sb-ita-media') === key);
        });

        this.items.forEach((el) => {
          el.classList.toggle('is-active', el.getAttribute('data-sb-ita-item') === key);
        });

        this.triggers.forEach((trigger) => {
          const isActive = trigger.getAttribute('data-sb-ita-trigger') === key;
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
      }
    }
  );
}
